import { api, unwrap } from '@/core/http';
import type { ProductBody } from '../domain/product';

const pr = (product_id: string) => ({ params: { path: { product_id } } });

export const productsApi = {
  list: () => unwrap(api.GET('/v1/products', { params: { query: { limit: 500 } } })),
  get: (id: string) => unwrap(api.GET('/v1/products/{product_id}', pr(id))),
  create: (body: ProductBody) => unwrap(api.POST('/v1/products', { body })),
  update: (id: string, body: ProductBody) =>
    unwrap(api.PUT('/v1/products/{product_id}', { ...pr(id), body })),
  publish: (id: string) => unwrap(api.POST('/v1/products/{product_id}/publish', pr(id))),
  unpublish: (id: string) => unwrap(api.POST('/v1/products/{product_id}/unpublish', pr(id))),
  archive: (id: string) => unwrap(api.POST('/v1/products/{product_id}/archive', pr(id))),
  remove: (id: string) => unwrap(api.DELETE('/v1/products/{product_id}', pr(id))),
};
